import { Global, ThemeProvider, css } from "@emotion/react"
import React, { type ReactNode } from "react"
import { byfolioTheme, createCssVariableMap, type ByfolioTheme } from "./theme"

export interface ByfolioProviderProps {
  readonly children: ReactNode
  readonly theme?: ByfolioTheme
  readonly includeGlobalStyles?: boolean
}

export interface ByfolioGlobalStylesProps {
  readonly theme?: ByfolioTheme
}

export const ByfolioGlobalStyles = ({
  theme = byfolioTheme,
}: ByfolioGlobalStylesProps) => (
  <Global
    styles={css({
      ":root": createCssVariableMap(theme),
      "*, *::before, *::after": {
        boxSizing: "border-box",
      },
      "@media (prefers-reduced-motion: reduce)": {
        "*, *::before, *::after": {
          scrollBehavior: "auto",
        },
      },
    })}
  />
)

export const ByfolioProvider = ({
  children,
  theme = byfolioTheme,
  includeGlobalStyles = true,
}: ByfolioProviderProps) => (
  <ThemeProvider theme={theme}>
    {includeGlobalStyles && <ByfolioGlobalStyles theme={theme} />}
    {children}
  </ThemeProvider>
)
